const TabSkeleton = () => (
  <div className="animate-pulse space-y-5">
    <div className="rounded-xl bg-white p-5 shadow-sm">
      <div className="mb-5 flex items-center gap-2">
        <div className="h-4 w-4 rounded bg-gray-200" />
        <div className="h-4 w-36 rounded bg-gray-200" />
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <div className="h-3 w-12 rounded bg-gray-200" />
          <div className="h-12 rounded-md border border-gray-100 bg-gray-100 sm:h-10" />
        </div>
        <div className="space-y-2">
          <div className="h-3 w-8 rounded bg-gray-200" />
          <div className="h-12 rounded-md border border-gray-100 bg-gray-100 sm:h-10" />
        </div>
      </div>
    </div>

    <div className="rounded-xl bg-white p-5 shadow-sm">
      <div className="mb-5 flex items-center gap-2">
        <div className="h-4 w-4 rounded bg-gray-200" />
        <div className="h-4 w-28 rounded bg-gray-200" />
      </div>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="space-y-3 rounded-lg border border-gray-100 bg-gray-50 p-4"
          >
            <div className="h-5 w-5 rounded bg-gray-200" />
            <div className="h-3.5 w-20 rounded bg-gray-200" />
            <div className="space-y-1.5">
              <div className="h-2.5 w-full rounded bg-gray-200" />
              <div className="h-2.5 w-3/4 rounded bg-gray-200" />
              <div className="h-2.5 w-1/2 rounded bg-gray-200" />
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <div className="rounded-xl bg-white p-5 shadow-sm">
        <div className="mb-5 flex items-center gap-2">
          <div className="h-4 w-4 rounded bg-gray-200" />
          <div className="h-4 w-20 rounded bg-gray-200" />
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="space-y-2">
              <div className="h-3 w-24 rounded bg-gray-200" />
              <div className="relative h-12 rounded-md border border-gray-100 bg-gray-100 sm:h-10">
                <div className="absolute inset-y-0 right-2 my-auto h-6 w-6 rounded-full bg-gray-200" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="rounded-xl bg-white p-5 shadow-sm">
        <div className="mb-5 flex items-center gap-2">
          <div className="h-4 w-4 rounded bg-gray-200" />
          <div className="h-4 w-20 rounded bg-gray-200" />
        </div>
        <div className="space-y-2">
          <div className="h-3 w-36 rounded bg-gray-200" />
          <div className="h-12 rounded-md border border-gray-100 bg-gray-100 sm:h-10" />
        </div>
      </div>
    </div>
  </div>
)

export default TabSkeleton
